import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import LoginBrandPanel from "@/components/LoginBrandPanel";

function LoginField({ label, type, value, onChange, testId, placeholder }) {
  return (
    <div>
      <label className="block font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted mb-2">
        {label}
      </label>
      <input
        type={type}
        required
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-3 py-2.5 bg-white border border-canvas-line text-ink text-sm focus:outline-none focus:border-ink transition-colors"
      />
    </div>
  );
}

function DemoCredentials() {
  return (
    <div className="mt-10 border-t border-canvas-line pt-6">
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-subtle mb-2">
        Demo accounts
      </div>
      <div className="font-mono text-[11px] text-ink-muted space-y-1">
        <div>admin@dealership.com / admin123</div>
        <div>staff@dealership.com / staff123</div>
      </div>
    </div>
  );
}

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@dealership.com");
  const [password, setPassword] = useState("admin123");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (!res.ok) setErr(res.error);
    else navigate("/");
  };

  return (
    <div className="min-h-screen flex">
      <LoginBrandPanel />
      <div className="flex-1 flex items-center justify-center px-6 py-12 bg-canvas">
        <div className="w-full max-w-sm">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink-muted mb-3">
            SIGN IN / OPERATOR ACCESS
          </div>
          <h1 className="font-display text-4xl font-bold tracking-tight text-ink mb-2">
            Welcome back.
          </h1>
          <p className="text-sm text-ink-muted mb-8">
            Enter your credentials to manage the floor.
          </p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <LoginField
              label="Email"
              type="email"
              value={email}
              onChange={setEmail}
              testId="login-email-input"
              placeholder="you@dealership.com"
            />
            <LoginField
              label="Password"
              type="password"
              value={password}
              onChange={setPassword}
              testId="login-password-input"
              placeholder="••••••••"
            />

            {err && (
              <div
                data-testid="login-error"
                className="px-3 py-2 border border-destructive text-destructive text-xs font-mono"
              >
                {err}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-ink text-white py-3 text-sm font-semibold tracking-tight hover:bg-brand transition-colors duration-150 flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
              <ArrowRight size={16} weight="bold" />
            </button>
          </form>

          <DemoCredentials />
        </div>
      </div>
    </div>
  );
}
